import React from 'react';
import { Field, useField } from 'formik';
import RichTextEditor from '@dashboard/lib/lexical/editors/RichTextEditor';

export const LexicalRichTextEditor = props => {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(props);

  const { setValue } = helpers;

  const onChange = value => {
    setValue(value);

    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <Field
      {...props}
      as={RichTextEditor}
      onChange={onChange}
      value={field.value}
    />
  );
};

export default LexicalRichTextEditor;
